import { BASE_URL, WORKSHOP_EVALUATION_QUESTION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopEvaluationQuestionInput } from "models/workshopEvaluationQuestions";


export async function getWorkshopEvaluationQuestions(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION_QUESTION + params);
  return response.data;
}
export async function addWorkshopEvaluationQuestion(data: IWorkshopEvaluationQuestionInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_EVALUATION_QUESTION, data);
  return response.data;
}
export async function editWorkshopEvaluationQuestion(data: IWorkshopEvaluationQuestionInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_EVALUATION_QUESTION + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopEvaluationQuestion(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_EVALUATION_QUESTION + "/" + id);
  return response.data;
}

export async function importExcel(data: FormData, id: string) {
  const response = await axios.post(`${BASE_URL}${WORKSHOP_EVALUATION_QUESTION}/import?workshopEvaluationId=${encodeURIComponent(id)}`, data);
  return response.data;
}

export const WorkshopEvaluationQuestionCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "titleAr",
    numeric: false,
    disablePadding: false,
    label: "T_title_ar",
  },
  {
    id: "dimension",
    numeric: false,
    disablePadding: false,
    label: "T_dimension",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_ar",
  },
  {
    id: "questionOrder",
    numeric: true,
    disablePadding: false,
    label: "T_question_order",
  },
  {
    id: "type",
    numeric: true,
    disablePadding: false,
    label: "T_type",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
